import { Link, useParams } from "react-router-dom";
import ShareButton from "@/components/feature/ShareButton";
import { formatDate, getNewsById, getRelatedNews } from "@/utils/content";

export default function NewsDetail() {
  const { id } = useParams();
  const item = getNewsById(id);

  if (!item) {
    return (
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
          <i className="ri-emotion-sad-line text-3xl" />
        </span>
        <h1 className="mt-5 font-heading text-xl font-bold text-foreground-950">未找到该资讯</h1>
        <p className="mt-2 text-sm text-foreground-600">该资讯可能已下架，请返回资讯列表浏览其它内容。</p>
        <Link
          to="/news"
          className="mt-6 rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          返回资讯列表
        </Link>
      </div>
    );
  }

  const related = getRelatedNews(item, 3);

  return (
    <div>
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-6">
          <nav className="flex items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <Link to="/news" className="hover:text-primary-600">最新资讯</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="truncate text-foreground-800">详情</span>
          </nav>
        </div>
      </div>

      <div className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px]">
          <article>
            <div className="flex flex-wrap items-center gap-3 text-sm text-foreground-500">
              <span className="rounded bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-700">
                {item.category}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line" />
                {formatDate(item.date)}
              </span>
            </div>
            <h1 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {item.title}
            </h1>

            <div className="mt-5 flex items-center justify-between gap-4">
              <p className="text-sm text-foreground-600 md:text-base">{item.summary}</p>
            </div>

            <div className="mt-6 overflow-hidden rounded-lg border border-background-200 bg-background-200">
              <img
                src={item.cover}
                alt={`${item.title} 资讯配图`}
                title={`火影忍者资讯 ${item.title}`}
                className="h-64 w-full object-cover md:h-96"
              />
            </div>

            <div className="mt-8 space-y-5">
              {item.content.map((paragraph) => (
                <p
                  key={paragraph.slice(0, 12)}
                  className="text-sm leading-loose text-foreground-700 md:text-base"
                >
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mt-8 flex items-center justify-between gap-4 border-t border-background-200 pt-6">
              <p className="text-xs text-foreground-500">
                本文由火影忍者动漫频道整理撰写，仅用于动漫文化交流。
              </p>
              <ShareButton title={`火影忍者资讯：${item.title}`} />
            </div>
          </article>

          <aside>
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h2 className="font-heading text-base font-bold text-foreground-950">相关资讯推荐</h2>
              <ul className="mt-4 space-y-4">
                {related.map((news) => (
                  <li key={news.id}>
                    <Link to={`/news/${news.id}`} className="group block">
                      <div className="h-28 w-full overflow-hidden rounded-md bg-background-200">
                        <img
                          src={news.cover}
                          alt={`${news.title} 配图`}
                          title={`火影忍者资讯 ${news.title}`}
                          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <h3 className="mt-2.5 line-clamp-2 text-sm font-medium leading-relaxed text-foreground-800 transition-colors group-hover:text-primary-600">
                        {news.title}
                      </h3>
                      <span className="mt-1 block text-xs text-foreground-400">
                        {formatDate(news.date)}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                to="/news"
                className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
              >
                查看全部资讯
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}